<template>
  <div>
    <!-- :before-close="handleClose" -->
    <el-drawer
      :title="title"
      :visible.sync="drawer"
      size="90%"
      :wrapperClosable="false"
    >
      <div class="form-center" v-loading="loading">
        <el-form
          :model="form"
          ref="form"
          label-width="100px"
          :rules="rules"
          :disabled="disabled"
        >
          <el-row>
            <el-col :span="8">
              <el-form-item label="入库单号" prop="Code">
                <el-input
                  v-model="form.Code"
                  placeholder="系统自动生成"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="入库时间" prop="InStorTime">
                <el-date-picker
                  v-model="form.InStorTime"
                  value-format="yyyy-MM-dd"
                  type="date"
                  style="width: 100%"
                  placeholder="请选择日期"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="供应商" prop="Code">
                <div style="width: 100%; display: flex; align-items: center">
                  <el-input
                    v-model="form.SupName"
                    placeholder="请选择供应商"
                    disabled
                    style="width: calc(100% - 60px)"
                  ></el-input>
                  <el-button style="width: 60px" type="primary" @click="openSup"
                    ><i class="el-icon-search"></i
                  ></el-button>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div style="line-height: 30px">
          <el-button type="primary" @click="addList" v-if="!disabled"
            >添加备件</el-button
          >
        </div>
        <el-table
          :data="tD_InStorDetails"
          ref="dialogTable"
          style="width: 100%"
          height="calc(100% - 70px)"
        >
          <el-table-column label="序号" width="50" type="index">
          </el-table-column>

          <el-table-column label="备件编号" align="center" prop="Code" sortable>
          </el-table-column>
          <el-table-column label="备件名称" align="center" prop="Name" sortable>
          </el-table-column>
          <el-table-column
            label="备件类型"
            align="center"
            prop="MaterialTypeName"
            sortable
          >
          </el-table-column>
          <el-table-column label="备件规格" align="center" prop="Spec" sortable>
          </el-table-column>
          <el-table-column
            label="单位"
            align="center"
            prop="storageName"
            sortable
          >
          </el-table-column>
          <el-table-column
            label="专属设备"
            align="center"
            prop="LocalId"
            width="200"
            sortable
          >
            <template slot-scope="scope">
              <div style="width: 100%; display: flex; align-items: center">
                <el-input
                  v-model="scope.row.device_name"
                  placeholder="通用设备"
                  disabled
                  style="width: calc(100% - 40px)"
                ></el-input>
                <el-button
                  style="
                    width: 30px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                  "
                  type="primary"
                  :disabled="disabled"
                  @click="openDevice(scope.$index)"
                  ><i class="el-icon-search"></i
                ></el-button>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="入库货位"
            align="center"
            prop="LocalId"
            sortable
          >
            <template slot-scope="scope">
              <SekectShelf
                ref="SekectShelf"
                v-model="scope.row.LocalId"
                :disabled="disabled"
                @select="selectShelf($event, scope.row)"
              ></SekectShelf>
            </template>
          </el-table-column>
          <el-table-column label="入库数量" align="center" prop="Num" sortable>
            <template slot-scope="scope">
              <el-input
                @input="NumChange($event, scope.row)"
                v-model="scope.row.Num"
                type="number"
                :disabled="disabled"
                :controls="false"
                style="width: 100%"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column label="单价" align="center" prop="Price" sortable>
            <template slot-scope="scope">
              <el-input
                @input="PriceChange($event, scope.row)"
                v-model="scope.row.Price"
                type="number"
                :disabled="disabled"
                :controls="false"
                style="width: 100%"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column label="总额" align="center" prop="TotalAmt" sortable>
          </el-table-column>
          <el-table-column
            label="操作"
            align="center"
            prop="op"
            v-if="!disabled"
          >
            <template slot-scope="scope">
              <el-button
                type="text"
                style="color: #f78989"
                size="mini"
                @click="tD_InStorDetails.splice(scope.$index, 1)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="footer" v-loading="loading">
        <el-button @click="close">取消</el-button>
        <el-button type="primary" @click="handleSubmit" v-if="!disabled"
          >保存</el-button
        >
        <el-button
          @click="handleAudit"
          type="success"
          v-if="title == '审核入库详情'"
        >
          审核通过</el-button
        >
      </div>
    </el-drawer>
    <Supplier ref="Supplier" type="radio" @select="selectSup"></Supplier>
    <Fittings ref="Fittings" @select="selectFittings"></Fittings>
    <DevDialog
      ref="DevDialog"
      @select="handleDevSelect"
      type="radio"
    ></DevDialog>
  </div>
</template>
<script>
import Supplier from '@/components/Supplier/Supplier.vue'
import Fittings from '@/components/Fittings/Fittings.vue'
import SekectShelf from '@/components/SekectShelf/SekectShelf.vue'
import DevDialog from '@/components/DevDialog/DevDialog.vue'
import Token from '@/utils/cache/TokenCache.js'
import moment from 'moment'
export default {
  data() {
    return {
      title: '',
      loading: false,
      token: 'Bearer ' + Token.getToken(),
      RoleList: [],
      tD_InStorDetails: [],
      form: {
        Code: '',
        InStorTime: '',
        SupName: '',
        SupId: '',
      },
      rules: {
        InStorTime: [
          { required: true, message: '请选择日期', trigger: 'change' },
        ],
      },
      drawer: false,
      disabled: false,
      row: {},
      devRow: {},
    }
  },
  props: {},
  components: { Supplier, Fittings, SekectShelf, DevDialog },
  methods: {
    handleDevSelect(rows) {
      let row = rows[0]
      this.$set(
        this.tD_InStorDetails[this.TableIndex],
        'device_name',
        row.device_name
      )
      this.$set(this.tD_InStorDetails[this.TableIndex], 'PackId', row.Id)
    },
    openDevice(TableIndex) {
      this.TableIndex = TableIndex
      this.$refs.DevDialog.openDialog()
    },
    handleAudit() {
      this.$confirm('是否审核通过？', {
        type: 'warning',
      }).then(() => {
        this.loading = true
        this.$http
          .post('/TD/TD_InStorage/InStorageAuditData', { id: this.row.Id })
          .then((resJson) => {
            this.loading = false
            if (resJson.Success) {
              this.$notify.success('操作成功!')
              this.$emit('success')
              this.close()
            } else {
              this.$notify.error(resJson.Msg)
            }
          })
      })
    },
    PriceChange(price, row) {
      if (Number(price) < 0) {
        this.$notify.error('价格不能为负数')
        this.$set(row, 'Price', 0)
      } else if (!/^\d+(\.\d{1,4})?$/.test(price)) {
        this.$notify.error('价格最多只能保留四位小数')
        const validPrice = parseFloat(price).toFixed(4)
        this.$set(row, 'Price', validPrice)
      }
      const formattedTotalAmt = ((row.Num || 0) * (row.Price || 0)).toFixed(4)
      const formattedTotalAmtWithCommas = Number(
        formattedTotalAmt
      ).toLocaleString('en-US', {
        minimumFractionDigits: 4,
        maximumFractionDigits: 4,
      })
      this.$set(row, 'TotalAmt', formattedTotalAmtWithCommas)
    },
    NumChange(num, row) {
      console.log(num, row)
      if (!Number.isInteger(Number(num))) {
        this.$notify.error('数量不能为小数或负数')
        this.$set(row, 'Num', Math.floor(Number(num)))
      } else if (Number(num) < 0) {
        this.$notify.error('数量不能为小数或负数')
        this.$set(row, 'Num', 0)
      } else if (Number(num) > 999999) {
        this.$notify.error('数量不能超过999999')
        this.$set(row, 'Num', 999999)
      }

      const formattedTotalAmt = ((row.Num || 0) * (row.Price || 0)).toFixed(4)
      const formattedTotalAmtWithCommas = Number(
        formattedTotalAmt
      ).toLocaleString('en-US', {
        minimumFractionDigits: 4,
        maximumFractionDigits: 4,
      })
      this.$set(row, 'TotalAmt', formattedTotalAmtWithCommas)
    },
    selectShelf(obj, row) {
      console.log(obj, row)
      this.$set(row, 'LocalName', obj.Name)
      this.$set(row, 'AreaId', obj.PB_StorArea.Id)
      this.$set(row, 'RackId', obj.PB_Rack.Id)
    },
    selectFittings(arr) {
      console.log(arr)
      if (this.tD_InStorDetails.length == 0) {
        arr.forEach((item) => {
          this.tD_InStorDetails.push({
            ...item,
            Id: '',
            MaterialId: item.Id,
            AreaId: '',
            RackId: '',
            LocalName: '',
            LocalId: '',
            Price: '',
            TotalAmt: '',
          })
        })
      } else {
        const duplicateIds = []
        arr.forEach((item) => {
          const exists = this.tD_InStorDetails.some(
            (detail) => detail.MaterialId === item.Id
          )
          if (exists) {
            duplicateIds.push(item.Name)
          } else {
            this.tD_InStorDetails.push({
              ...item,
              Id: '',
              MaterialId: item.Id,
              AreaId: '',
              RackId: '',
              LocalId: '',
              Price: '',
              TotalAmt: '',
            })
          }
        })
        if (duplicateIds.length > 0) {
          this.$notify.warning(
            `以下备件已存在，未重复添加: ${duplicateIds.join(', ')}`
          )
        }
      }
    },
    addList() {
      this.$refs.Fittings.openDialog()
    },
    selectSup(arr) {
      console.log(arr)
      this.$set(this.form, 'SupId', arr[0].Id)
      this.$set(this.form, 'SupName', arr[0].Name)
    },
    openSup() {
      this.$refs.Supplier.openDialog()
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 20

      if (!isJPG) {
        this.$notify.error('上传图片只能是 JPG 或 PNG 格式!')
      }
      if (!isLt2M) {
        this.$notify.error('上传头像图片大小不能超过 20MB!')
      }
      return isJPG && isLt2M
    },
    handleAvatarSuccess(res) {
      console.log(res, 'res')
      if (res.status == 'done') {
        this.form.HeadImg = res.url

        console.log(this.form.HeadImg)
      } else {
        this.$notify.error(res.Msg)
      }
    },
    getRoleList() {
      this.$http
        .post('/Base_Manage/Base_Role/GetDataList', {
          SortField: 'CreateTime',
          SortType: 'Desc',
        })
        .then((resJson) => {
          if (resJson.Success) {
            this.RoleList = resJson.Data
          }
        })
    },
    handleSubmit() {
      console.log(this.tD_InStorDetails, 'tD_InStorDetails')

      this.$refs.form.validate((valid) => {
        if (!valid) {
          return this.$notify.error('请检查输入项')
        }
        if (this.tD_InStorDetails.length == 0) {
          return this.$notify.error('请添加备件')
        }
        let flag = this.tD_InStorDetails.every((item) => {
          return item.LocalId != '' && Number(item.Num) > 0
        })
        if (!flag) {
          return this.$notify.error('请选择入库货位和入库数量')
        }
        this.loading = true
        this.$http
          .post('/TD/TD_InStorage/SaveInStorageData', {
            tD_InStorage: { ...this.form },
            tD_InStorDetails: this.tD_InStorDetails,
          })
          .then((resJson) => {
            this.loading = false

            if (resJson.Success) {
              this.$notify.success('操作成功!')
              this.$emit('success')
              this.close()
            } else {
              this.$notify.error(resJson.Msg)
            }
          })
      })
    },
    openForm(title, row = {}, disabled = false) {
      this.drawer = true
      this.disabled = disabled
      // this.getRoleList();
      this.row = row
      this.form = {
        Code: '',
        SupName: '',
        SupId: '',
        InStorTime: moment().format('YYYY-MM-DD'),
      }
      this.tD_InStorDetails = []
      this.$nextTick(() => {
        this.$refs.form.resetFields()
      })
      this.title = title
      if (row.Id) {
        this.getInfo(row.Id)
      }
    },
    getInfo(id) {
      this.loading = true
      this.$http
        .post('/TD/TD_InStorage/GetInStorageData', { id: id })
        .then((resJson) => {
          this.loading = false
          if (resJson.Success) {
            this.form = resJson.Data.tD_InStorage
            this.tD_InStorDetails = resJson.Data.tD_InStorDetails
          } else {
            this.$notify.error(resJson.Msg)
          }
        })
    },
    close() {
      this.drawer = false
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(() => {
          done()
        })
        .catch(() => {})
    },
  },
  mounted() {},
  created() {},
  computed: {},
  watch: {},
}
</script>
<style lang="scss" scoped>
::v-deep .el-drawer__header {
  margin: 0;
  padding: 20px;
}
.form-center {
  height: calc(100vh - 120px);
  padding: 20px;
}
.footer {
  height: 40px;
  line-height: 40px;
  text-align: right;
  padding: 0 20px;
}
::v-deep .avatar-uploader .el-upload {
  width: 100px;
  height: 100px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

::v-deep .avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 65px;
  height: 60px;
  line-height: 60px;
  text-align: center;
}
</style>
